export const UPDATE_SEARCHLIST = 'erfSearch/updateResults'

export const RESET_FILTERS = 'erfSearch/reset'
export const RESET_RESULTS = 'erfSearch/resetTableData'

export const UPDATE_CONTROL_NO = 'erfAdd/getControlNo'
export const GET_DETAIL = 'erf/getDetails'

export const SET_CONFIRM_MODAL = 'erfSearch/setConfirmModal'
export const HIDE_CONFIRM_MODAL = 'erfSearch/hideConfirmModal'
export const SHOW_CONFIRM_MODAL = 'erfSearch/showConfirmModal'

export const SET_CHANGE_APPROVER_MODAL = 'erfSearch/setChangeApproverModal'
export const HIDE_CHANGE_APPROVER_MODAL = 'erfSearch/hideChangeApproverModal'
export const SHOW_CHANGE_APPROVER_MODAL = 'erfSearch/showChangeApproverModal'

export const FETCH_EMPLOYEE_SV_DDL = 'erfSearch/setEmployeeSVDDL'
export const UPDATE_USER_POSITION = 'erfSearch/setEmployeePosition'

// SEARCH FILTER TYPES
export const APPLY_FILTERS = 'erfSearch/applySearchFilter'
export const CHG_FILTER_DATA = 'erfSearch/changeFilterField'
export const CHG_FILTER_PAGE = 'erfSearch/changePage'
export const CHG_FILTER_PAGE_SIZE = 'erfSearch/changePageSize'
export const CHG_FILTER_SORT = 'erfSearch/changeSortModel'
export const IS_LOADING = 'erfSearch/isLoading'
export const CHG_SELECTED_ROWS = 'erfSearch/changeSelected'
export const HIDE_LIST_ALERT = 'erfSearch/hideAlert'
export const SET_LIST_ALERT = 'erfSearch/setAlertModal'

// ADD FORM TYPES
export const CHG_FIELD = 'erfAdd/changeField'
export const CHG_STATUS = 'erfAdd/changeStatus'
export const CHG_EMPLOYEE_ID = 'erfAdd/changeEmployeeId'
export const CHG_INCOME_ID = 'erfAdd/changeIncomeId'
export const CHG_AMOUNT = 'erfAdd/changeAmount'
export const CHG_EFFECTIVE_DATE = 'erfAdd/changeEffectiveData'
export const CHG_MEMO = 'erfAdd/changememo'
export const RESET_ADD_DATA = 'erfAdd/resetAddData'
export const UPD_ADD_ALERT = 'erfAdd/updateAlert'
export const HIDE_ADD_ALERT = 'erfAdd/hideAlert'
export const UPD_ADD_MEMO_CHAR_COUNT = 'erfAdd/updateMemoCharCount'
export const INSERT_LOADING = 'erfAdd/isLoading'
export const SET_HOLIDAY_DATES = 'erfAdd/setHolidayDates'

// DETAIL FORM TYPES
export const UPD_DETAIL_TITLE = 'erfDetail/changeTitle'
export const CHG_DETAIL_DATA = 'erfDetail/changeFieldData'
export const UPD_DETAIL_MODE = 'erfDetail/changeMode'
export const HAS_DETAIL_LOADED = 'erfDetail/hasDetailLoaded'
export const SET_DETAIL_DATA = 'erfDetail/setDetailData'
export const UPD_AMOUNT = 'erfDetail/changeAmount'
export const HIDE_DETAIL_ALERT = 'erfDetail/hideAlert'
export const UPD_DETAIL_MEMO_CHAR_COUNT = 'erfDetail/updateMemoCharCount'
export const UPD_DETAIL_DATA = 'erfDetail/updateDetailData'
export const SET_LOAN_LEDGER_DATA = 'erfDetail/seterfLedgerData'
export const SHOW_LOAN_LEDGER = 'erfDetail/showerfLedgerData'
export const HIDE_LOAN_LEDGER = 'erfDetail/hideerfLedgerData'
export const SET_DETAIL_CONFIRM_MODAL = 'erfDetail/setConfirmModal'
export const HIDE_DETAIL_CONFIRM_MODAL = 'erfDetail/hideConfirmModal'
export const SHOW_DETAIL_CONFIRM_MODAL = 'erfDetail/showConfirmModal'
export const SET_DETAIL_ALERT = 'erfDetail/setAlertModal'

